<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
<form data-vv-scope="addResetScope">

          <div class="vx-row no-gutter justify-center items-center">


            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">


                  <vs-divider><h3 class="mb-4">Reset Password</h3></vs-divider>

                <div>
                  <vs-input
                      name="recent password"
                      data-vv-name="recentpassword"
                      type="password"
                      v-validate="'required|min:8'"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Recent Password"
                      v-model="data.recent_password"
                      class="w-full"/>
                      <div v-if="errors.has('addResetScope.recentpassword')"
                          style="color:red;"
                        class="invalid-feedback">{{ errors.first('addResetScope.recentpassword') }}</div>
                        <vs-input
                      name="password"
                      type="password"
                      ref="Password"
                        data-vv-name="Password"
                      v-validate="'required|min:8'"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="New Password"
                      v-model="data.password"
                      class="w-full"/>
                        <div v-if="errors.has('addResetScope.Password')"
                          style="color:red;"
                        class="invalid-feedback">{{ errors.first('addResetScope.Password') }}</div>
                      <vs-input
                      name="confirm"
                      data-vv-name="Confirm Password"
                      type="password"
                      v-validate="'required|min:8|confirmed:Password'"                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Confirm Password"
                      v-model="data.password_confirmation"
                      class="w-full"/>
                      <span class="text-danger" v-show="errors.has('addResetScope.Confirm Password')">{{ errors.first('addResetScope.Confirm Password') }}</span>

                  <vs-divider><vs-button @click="checkValidation" class="float-right">Reset</vs-button></vs-divider>

                  <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                    <h5 class="mb-4 text-center" v-if="message">You Have Successfully Reset Your Password</h5>
                  </div>

                  <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                    <h5 class="mb-4 text-center" v-if="notMatched">Your Password & Confirm Password Not Matched</h5>
                  </div>

                </div>

              </div>
            </div>
          </div>
          </form>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { reset_password } from '@/api/login'
// ResetPassword
export default{
  name: 'reset-password',
  components: {

  },
  data () {
    return {
      data:{
        recent_password: '',
        password_confirmation: '',
        password: ''
      },
      message: false,
      notMatched: false,
      error: false
    }
  },
  methods: {
    checkValidation () {
      this.$validator.validateAll('addResetScope').then(valid => {
        if (valid) {
          this.resetPassword()
        } else {
          this.$vs.notify({
            title: 'Waring',
            text: 'Validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })

    },
    resetPassword () {
      if (this.data.recent_password !== '' && this.data.password_confirmation !== '' && this.data.password !== '') {
        if (this.data.password_confirmation === this.data.password) {
          reset_password(this.data)
            .then(res => {
              
              this.message = true
              this.$vs.notify({
                title: 'Success',
                text: 'Password Changed Successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
              this.$router.push({name: 'dashboard-analytics'}).catch(() => {})
            }).catch(e => {
              
              this.$vs.notify({
                title: 'Error',
                text: 'Given Password is Incorrect',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        }
      } else {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, 3000)

      }

    }
  }
}
</script>

<style lang="scss">


.error{
  margin-bottom:10 px;
}


</style>